import DateTimeHelper from '@/components/mixins/DateTimeHelper'

export default {
  mixins: [DateTimeHelper],
  head: {
    title () {
      if (this.leurisHead) {
        return {
          inner: this.leurisHead.inner,
          separator: '|',
          complement: this.complement
        }
      } else { /* should no longer be used, but keep as fallback */
        return {
          inner: 'leuris',
          separator: '|',
          complement: this.title
        }
      }
    }
  },
  computed: {
    title () {
      if (typeof this.complementTitle === 'object') {
        return `${this.$gettext(this.complementTitle.inner)} ${this.complementTitle.separator || ''} ${this.$gettext(this.complementTitle.complement)}`
      } else {
        return this.$gettext(this.complementTitle)
      }
    },
    complement () {
      let complement = this.leurisHead.complement
      let separator = this.leurisHead.separator || ''
      if (typeof complement === 'object') {
        return complement.map(c => this.$gettext(c)).join(` ${separator} `)
      } else {
        return this.$gettext(complement)
      }
    }
  },
  watch: {
    currentLocale () { this.$emit('updateHead') }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/DynamicTitle.js